module.exports = __webpack_public_path__ + "static/media/seal work2.21b485f9.png";